// axios配置  可自行根据项目进行更改，只需更改该文件即可，其他文件可以不动
import {isString,merge} from 'es-toolkit/compat';
import mitt from 'mitt-utils';
import { DialogPlugin } from 'tdesign-vue-next';
import { minW } from '../../constants/index';
import {  setKeyJsonStr ,getKeyJson} from '../localStorage';

import { useUserStore } from '../../store/modules/user';
import { authExpired, isN, loginHref, toast } from '../../utils/tools';
import { VAxios } from './Axios';
import type { AxiosTransform, CreateAxiosOptions } from './AxiosTransform';
import { fmtHeadersAuthSid, formatRequestDate, joinTimestamp, setObjToUrlParams } from './utils';

// 使普通数据变响应式的函数
// 如果有两套环境，我们平时调试所需要的服务器不一样，就可以用env来区分
//const env = import.meta.env.MODE || 'development';
// 如果是mock模式 或 没启用直连代理 就不配置host 会走本地Mock拦截 或 Vite 代理
//const host = env === 'mock' || !proxy.isRequestProxy ? '' : proxy[env].host;
// 可以读取到外层的 env
let host ;

const login = getKeyJson('login')
if(login){
  host = login.host;
}
export const initProxyHost = (configHost: string) => {
  host = configHost;
};
// host = "http://127.0.0.1:20050";

// 数据处理，方便区分多种处理方式
const transform: AxiosTransform = {
  // 处理请求数据。如果数据不是预期格式，可直接抛出错误
  //对于此处已经标记code为-100的，相当于已经处理，后续不再处理
  transformRequestHook: (res, options) => {
    //res为undefined场景：超时，还有其它么？
    if(isN(res)){
      toast('网络请求异常', 3);
      return;
    }
    
    const method = res.config.method;
    console.log(`---> Response ${method} ${res.config.url}`, options);

    const { isTransformResponse, isReturnNativeResponse } = options;

    const userStore: any = useUserStore();
    const { serUrl } = userStore;
    const staticSer = serUrl || '';
    // 如果204无内容直接返回
    try{
      if (res.status === 204 || method === 'PUT' || method === 'PATCH') {
        return res;
      }
    }catch(e){
      console.error("返回请求错误异常", e);
      /*if (env === 'release') {
        // window.location.assign(staticSer+'#login');  
      }else{
        // window.location.assign('/login');  
      }*/      
      return {code:-100};
    }

    //附件下载成功
    if(res['headers']['content-disposition']){
      //记录下当前类型比如arraybuffer就是这个
      let reqType = res['config']['responseType'];
      res['headers']['f_type'] = reqType;
      return {code: 0 ,value: res['data'], 'header': res['headers']};
    }
    // 是否返回原生响应头 比如：需要获取响应头时使用该属性
    if (isReturnNativeResponse) {
      return res;
    }
    // 不进行任何处理，直接返回
    // 用于页面代码可能需要直接获取code，data，message这些信息时开启
    if (!isTransformResponse) {
      return res.data;
    }

    // 错误的时候返回
    const { data } = res;
    if (!data) {
      throw new Error('接口返回错误');
    }

    //普通请求reqType为undefined。有的请求虽然是arrayBuffer，但失败时仍然返回JSON，此时需要将data转回去
    let code = -1;
    let value:any;
    let reqType = res['config']['responseType'];
    let contType:string = res['headers']['content-type'];
    if(reqType !== undefined && reqType.includes('arraybuffer')){
      if(contType && contType.includes('application/json')){
        let uint8Msg = new Uint8Array(<ArrayBuffer><unknown>data);
        //这种方式汉字会乱码
        //let decodedString = String.fromCharCode.apply(null, uint8Msg);
        let decodedString = new TextDecoder('utf-8').decode(uint8Msg);
        //转JSON
        let d = JSON.parse(decodedString);
        code = d['code'];
        value = d['value'];
      }else{
        toast('下载失败', 3);
        return  {code:-100};
      }      
    }else{
      code = data['code'];
      value = data['value'];
    }
    
    if (code === 115 || value === '没有Token') { 
      userStore.logout();
      toast('没有权限,请登陆', 3);
      setTimeout(() => {
        loginHref('login');
      }, 2);
      
      return {code:-100};
    }

    //正常返回4xx
    if(res.status === 403 || code === 403){
      console.error(`emit ${code}`);
      setTimeout(()=>{
        mitt.emit('app_mitt', {flg:'r403'});
      });
      return {code:-100};;
    }
    //5xx的处理不能包含>=600的  code是返回200但内部捕捉到了5xx，一般不是自己的微服务异常，而是要获取结果的对方
    if((res.status >= 500 && res.status < 600) || (code >= 500 && code <600)){
      // window.location.assign('/result/500');
      console.error(`emit ${code}`);
      setTimeout(()=>{
        //用router不管用，是因为router必须放到setup中
        // router.push('/result/500'); 
        mitt.emit('app_mitt', {flg:'r500'});
      });
      return {code:-100};
    }
    
    if (code === 101) {
      // 101就更新本地内存中的信息，重新发送当前请求
      // toast(value['info'],3);
      let val101 = value;
      let vmsg = '';
      try{
        val101 = JSON.parse(value);
      }catch(e){
        // toast(value,3);
      }
      vmsg = val101['info'];
      delete val101['info'];
      setKeyJsonStr('auth', val101);
      userStore.auth = val101; 
    } else if (code === 102 || code === 103 || code === 105) {
      authExpired(value);//不要stringfy，否则多带双引号
    }

    if (data) {
      return data;
    }

    throw new Error(value || '请求接口错误');
  },

  // 请求前处理配置
  beforeRequestHook: (config, options) => {
    const { apiUrl, isJoinPrefix, urlPrefix, joinParamsToUrl, formatDate, joinTime = true } = options;

    // 添加接口前缀
    if (isJoinPrefix && urlPrefix && isString(urlPrefix)) {
      config.url = `${urlPrefix}${config.url}`;
    }

    // 将baseUrl拼接
    if (apiUrl && isString(apiUrl)) {
      if(!config.url.includes(apiUrl)){
        console.log(`before 拼接url ${apiUrl}  ${config.url}`)
        config.url = `${apiUrl}${config.url}`;
        console.log(`after 拼接url ${config.url}`)
      }else {
        console.log(`尝试拼接apiUrl,但是config.url包含apiUrl> ${apiUrl} , ${config.url}`)
      }
    }
    const params = config.params || {};
    const data = config.data || false;

    if (formatDate && data && !isString(data)) {
      formatRequestDate(data);
    }
    if ((config.method?config.method.toUpperCase():'') === 'GET') {
      if (!isString(params)) {
        // 给 get 请求加上时间戳参数，避免从缓存中拿数据。
        config.params = Object.assign(params || {}, joinTimestamp(joinTime, false));
      } else {
        // 兼容restful风格
        config.url = `${config.url + params}${joinTimestamp(joinTime, true)}`;
        config.params = undefined;
      }
    } else if (!isString(params)) {
      if (formatDate) {
        formatRequestDate(params);
      }
      if (
        Reflect.has(config, 'data') &&
        config.data &&
        (Object.keys(config.data).length > 0 || data instanceof FormData)
      ) {
        config.data = data;
        config.params = params;
      } else {
        // 非GET请求如果没有提供data，则将params视为data
        config.data = params;
        config.params = undefined;
      }
      if (joinParamsToUrl) {
        config.url = setObjToUrlParams(config.url as string, { ...config.params, ...config.data });
      }
    } else {
      // 兼容restful风格
      config.url += params;
      config.params = undefined;
    }

    /* 发布版如果地址不一样，可以处理
    if (env === 'release') {
    }
    */

    // html 类型
    if (config['htmlType']) {
      if (!config['headers']) config['headers'] = {};
      config['headers']['Content-Type'] = config['htmlType'];
      config['headers']['accept'] = config['htmlType'];
    }


    //这个url是全地址
    console.log(`---> Interface Request Hook ${config}`);
    return config;
  },

  // 请求拦截器处理
  requestInterceptors: (config, options) => {
    fmtHeadersAuthSid((config as Recordable).headers);

    if (config['header']) {
      for (const k in config['header']) {
        (config as Recordable).headers[k] = config['header'][k];
      }
      delete config['header'];
    }

    // console.log(`Request Interceptors ---> ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },

  // 响应拦截器处理
  responseInterceptors: (res) => {
    return res;
  },

  // 响应错误处理
  responseInterceptorsCatch: (error: any) => {
    console.error('rsp catch err');
    const { config, response } = error;
    
    //Response为undefined的场景：
    //开始都正常运行，但突然微服务异常
    //Axio导致的超时。比如设置了10秒超时，但没下载完
    if(response === undefined || response === null){
      const userStore = useUserStore();//将微服务地址部分去掉
      console.error(`emit response null,msg: ${error['message']}`);//如：Axios错误 "timeout of 30000ms exceeded"
      //api自身会toast错误，此处就不弹出了--此处弹还有个问题，就是多个api就弹出多个
      //toast(`异常：${error['message']}`,3);
      mitt.emit('app_mitt', {flg:'r500', msg:error['message'], info:error['code'], url:config.url.replace(userStore.serUrl,'')});
      return;
    }
    //4xx~5xx是服务端保持与http协议一致的，其余的有具体含义，还需要正常走下去
    if(response['status'] >=500 && response['status'] <600){
      const token: any = getKeyJson('auth');
      if(token){ 
        //有token就说明登录成功了，才能显示展示页面，跳转5xx
        //iam正常，微服务不正常，登录，就能进来
        setTimeout(()=>{ 
          mitt.emit('app_mitt', {flg:'r500', info:`${response['status']} ${response['statusText']}`, url:config.url});
        });
      }else{
        //没有token，不能跳转5xx展示页，只能弹框
        const confirmDia = DialogPlugin.alert({
          header: `提示信息：${response.config.url}`,
          body: response['data'],
          width: `${minW()}`,
          //     body: '服务器异常,请稍候重试!',
          theme:'warning',
          confirmBtn: '确定',
          onConfirm: ({ e }) => {
            confirmDia.hide(); 
          },
          onClose:(e) => {
            confirmDia.hide(); 
          }
        });
      }
      return ;
    }
    
    //这个是http协议自身返回了4xx，不是服务端返回的。直接弹出一个页面即可
    if(response['status'] >=400 && response['status'] <500){
      //直接处理成r4xx，可能找不到，
      mitt.emit('app_mitt', {flg:`r${response['status']}`, info:`${response['status']} ${response['statusText']}`, url:config.url});
      return;
    }

    if (!config || !config.requestOptions.retry) return Promise.reject(error);

    config.retryCount = config.retryCount || 0;

    if (config.retryCount >= config.requestOptions.retry.count) return Promise.reject(error);

    config.retryCount += 1;

    const backoff = new Promise((resolve) => {
      setTimeout(() => {
        resolve(config);
      }, config.requestOptions.retry.delay || 1);
    });
    config.headers = { ...config.headers, 'Content-Type': 'application/json;charset=UTF-8' };

    //不要执行缓存清理，会导致后续都无法处理
    const userStore = useUserStore();
      //userStore.logout();
      // toast('请求错误,请重新登录', 3);
      //setTimeout(() => {
        // window.location.assign('/login');
      //}, 200);
      // return ;

    return backoff.then((config) => request.request(config));
  },
};

function createAxios(opt?: Partial<CreateAxiosOptions>) {
    console.log('👉 VAxios =', VAxios);
  console.log('👉 typeof VAxios =', typeof VAxios);
  console.log('👉 VAxios.prototype =', VAxios && VAxios.prototype);
  return new VAxios(
    merge(
      <CreateAxiosOptions>{
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Authentication#authentication_schemes
        // 例如: authenticationScheme: 'Bearer'
        authenticationScheme: '',
        // 超时：30
        timeout: 30 * 1000,
        // 携带Cookie
        // withCredentials: true,
        // 头信息
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        // 数据处理方式
        transform,
        // 配置项，下面的选项都可以在独立的接口请求中覆盖
        requestOptions: {
          // 接口地址
          apiUrl: host,
          // 是否自动添加接口前缀
          isJoinPrefix: false,
          // 接口前缀
          // 例如: https://www.baidu.com/api
          // urlPrefix: '/api'
          urlPrefix: '/api',
          // 是否返回原生响应头 比如：需要获取响应头时使用该属性
          isReturnNativeResponse: false,
          // 需要对返回数据进行处理
          isTransformResponse: true,
          // post请求的时候添加参数到url
          joinParamsToUrl: false,
          // 格式化提交参数时间
          formatDate: true,
          // 是否加入时间戳
          joinTime: true,
          // 忽略重复请求
          ignoreRepeatRequest: true,
          // 是否携带token
          withToken: true,
          // 重试
          retry: {
            count: 3,
            delay: 1000,
          },
        },
      },
      opt || {},
    ),
  );
}


let requestInstance: any = null;

/**
 * 获取 axios 实例（懒加载）
 */
function getRequestInstance() {
  if (!requestInstance) {
    requestInstance = createAxios();
  }
  return requestInstance;
}

/**
 * request 代理对象
 *
 * 用法不变：
 *   request.get(...)
 *   request.post(...)
 */
const request = new Proxy({}, {
  get(_, key: string) {
    const instance = getRequestInstance();

    const value = instance[key];

    // 防止访问不存在的方法
    if (value === undefined) {
      console.warn(`[request] 方法不存在: ${key}`);
      return undefined;
    }

    // 如果是函数，绑定 this
    if (typeof value === 'function') {
      return value.bind(instance);
    }

    return value;
  }
});

export const proxyRequest = function () {
  return createAxios();
}